import React, { useState, useEffect } from 'react';

import Modal from 'react-bootstrap/Modal'

export default function MethodologiesHTML(props) {

    const [methodologyModal, setMethodologyModal] = useState(false);

	return (
        <div className="row">
                <div className="col-md-12">
                <div className="vm">
            
                    <p>This information should not be relied upon as research, investment advice or a recommendation regarding the funds or any security in particular. This information is strictly for illustrative and educational purposes and is subject to change. This information does not represent the actual current, past or future holdings of any BlackRock client.</p>
                </div>
                </div>




                <Modal
                size="lg"
                show={methodologyModal}
                onHide={() => setMethodologyModal(false)}
                dialogClassName="modal-90w"
                aria-labelledby="example-modal-sizes-title-lg">	
    
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Methodology
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
            
                
                    <p>The “Bond Pyramid” experience (the “tool”) is designed to help investors learn how BlackRock actively managed bond mutual funds and iShares bond ETFs can work together in a portfolio to help clients achieve their financial goals. BlackRock mapped relevant Morningstar categories to the Bond Pyramid goals (income, capital preservation and equity diversification) based on the category’s historical characteristics and role in a portfolio.  BlackRock actively managed mutual funds and iShares ETFs were selected that have greater than $1b in assets under management and are the lowest cost option (based on net expense ratio) by vehicle, Morningstar category and Bond Pyramid goal. For flexible municipal bond funds such as the BlackRock Strategic Municipal Opportunities Fund, BlackRock assigns the funds to the Bond Pyramid’s capital preservation goal due the funds’ historical characteristics, which tend to more closely align to this goal.</p>



                    <p>The tool and products shown are not customized for any particular portfolio or investment circumstance. BlackRock, iShares and other third-party firms may consider other products that also relate to the outcomes shown. The outcomes shown are for illustrative purposes only and do not represent all possible investor outcomes. The funds shown are intended to illustrate possible investment ideas to consider. This information should not be relied upon as research, investment advice, or a recommendation regarding any products, strategies, or any security in particular. Any fund selection is not tailored to the investment objectives or needs of any particular investor. Investors should consult with their financial professionals prior to making an investment decision.</p>

                    <p>Please select “View all funds” to view and consider all BlackRock funds and iShares ETFs.</p>

                    <p>As of October 31, 2023. BlackRock funds and iShares ETFs launched after June 30, 2020 are not displayed in the tool. BlackRock and iShares product selections are reviewed quarterly to ensure the mutual funds and ETFs included in the tool meet the defined criteria defined. All other data is updated quarterly.</p>
                </Modal.Body>
            </Modal>



        </div>

        
                

	)
}